import { styled } from 'styled-components';

export const StyledFormField = styled.fieldset`
  position: relative;
  text-align: left;
  width: 100%;
`;
